import { QuillEditor } from '../../../components/common/quill-editor/quill-editor';
interface Iprops {
  value: string;
  onChange: (_value: string) => void;
  enableLink?: boolean;
  id?: number;
}

const QuilHelper = ({ onChange, value, enableLink = true, id }: Iprops) => {
  return (
    <div>
      <QuillEditor
        value={value}
        enableLink={enableLink}
        onChange={onChange}
        id={id}
      />
    </div>
  );
};

export default QuilHelper;
